import Input from "antd/es/input";

import React from "react";
import FunctionalFormFieldsEditor from "@containers/management/FunctionalForm/FunctionalFormFieldsEditor";
import EquipmentCategoryLookup from "@containers/Lookup/EquipmentCategoryLookup";
import CompanyLookup from "@containers/Lookup/CompanyLookup";
import Select from "@components/ResponsiveSelect";


export const FunctionalFormFormFields = (formRef) => {
    return [
        {
            title: 'key',
            name: 'id',
            order: 0,
            visible: false,
            length: 0,
            type: 'text',
        },
        {
            title: 'Name',
            name: 'name',
            order: 1,
            visible: true,
            length: "w-full",
            type: 'text',
            required: true,
            render: <Input/>,
        },
        {
            title: 'Form Type',
            name: 'form_type',
            order: 2,
            visible: true,
            length: "w-full",
            type: 'select',
            required: true,
            render: (
                <Select style={{width: '100%'}}>
                    <Select.Option value="functional_test">Functional Test</Select.Option>
                    <Select.Option value="pm_checklist">PM Checklist</Select.Option>
                </Select>
            ),
        },
        {
            title: 'Description',
            name: 'description',
            order: 3,
            visible: true,
            length: "w-full",
            type: 'text',
            render: <Input.TextArea rows={2}/>,
        },
        {
            title: 'Equipment Category',
            name: 'equipment_category',
            order: 4,
            visible: true,
            length: "w-full",
            type: 'Lookup_text',
            render: (value) => <EquipmentCategoryLookup value={value} formRef={formRef}/>,
        },
        {
            title: 'Company',
            name: 'company',
            order: 5,
            visible: true,
            length: "w-full",
            type: 'Lookup_text',
            render: (value) => <CompanyLookup value={value} formRef={formRef}/>,
        },
        {
            title: 'Fields',
            name: 'fields',
            order: 8,
            visible: true,
            length: "w-full",
            type: 'customJSON',
            render: (value) => <FunctionalFormFieldsEditor value={value} formRef={formRef}/>,
        },
    ];
};
